"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpRequestClose_1 = require("../Bandwidth/Constants/HttpRequestClose");
var EventEmitter_1 = require("../Event/EventEmitter");
var DEFAULT_CONFIG_1 = require("./Constants/DEFAULT_CONFIG");
var HttpRequestMonitor = /** @class */ (function () {
    function HttpRequestMonitor(shaka, bandwidthEstimation) {
        this.eventEmitter = new EventEmitter_1.default();
        this.activeHttpRequests = {};
        this.shaka = shaka;
        this.bandwidthEstimation = bandwidthEstimation;
        this.configure(DEFAULT_CONFIG_1.default);
    }
    HttpRequestMonitor.prototype.shutdown = function () {
        this.clearIntervalBandwidthEstimate();
    };
    HttpRequestMonitor.prototype.configure = function (inConfig) {
        if (undefined !== inConfig.intervalBandwidthEstimate) {
            this.clearIntervalBandwidthEstimate();
        }
        this.config = Object.assign({}, DEFAULT_CONFIG_1.default, inConfig);
        if (undefined !== inConfig.intervalBandwidthEstimate) {
            this.createIntervalBandwidthEstimate();
        }
    };
    HttpRequestMonitor.prototype.getConfig = function () {
        return this.config;
    };
    HttpRequestMonitor.prototype.on = function (event, handler) {
        return this.eventEmitter.on(event, handler);
    };
    HttpRequestMonitor.prototype.getActiveHttpRequests = function () {
        return Object.values(this.activeHttpRequests).map(function (internalRequest) { return internalRequest.request; });
    };
    HttpRequestMonitor.prototype.onHttpRequestOpen = function (httpRequest) {
        var activeHttpRequest = {
            httpRequest: httpRequest,
            loaded: 0,
            total: 0
        };
        var internalActiveHttpRequest = {
            request: activeHttpRequest,
            timeoutFirstByte: undefined,
            timeoutLoad: undefined,
            startTime: Date.now()
        };
        var requestType = httpRequest.getRequestType();
        if (requestType === this.shaka.net.NetworkingEngine.RequestType.SEGMENT) {
            this.createTimeoutFirstByte(internalActiveHttpRequest);
            this.createTimeoutLoad(internalActiveHttpRequest);
        }
        var id = httpRequest.id, params = httpRequest.params;
        this.activeHttpRequests[id] = internalActiveHttpRequest;
        this.bandwidthEstimation.onHttpRequestOpen(id, requestType);
        var uri = params.uri, request = params.request;
        this.emit('http-request-open', {
            id: id,
            requestType: requestType,
            uri: uri,
            request: request
        });
    };
    HttpRequestMonitor.prototype.onHttpRequestProgress = function (httpRequest, loaded, total) {
        var id = httpRequest.id;
        if (id in this.activeHttpRequests) {
            var internalActiveHttpRequest = this.activeHttpRequests[id];
            if (internalActiveHttpRequest.timeoutFirstByte) {
                this.clearTimeoutFirstByte(internalActiveHttpRequest);
                this.bandwidthEstimation.onHttpRequestFirstByte(id);
                this.emit('http-request-firstbyte', {
                    id: id
                });
            }
            var activeHttpRequest = internalActiveHttpRequest.request;
            activeHttpRequest.loaded = loaded;
            activeHttpRequest.total = total;
        }
        this.bandwidthEstimation.onHttpRequestProgress(id, loaded, total);
        this.emit('http-request-progress', {
            id: id,
            loaded: loaded,
            total: total
        });
    };
    HttpRequestMonitor.prototype.onHttpRequestLoad = function (httpRequest) {
        this.onHttpRequestClose(httpRequest, HttpRequestClose_1.default.Load);
    };
    HttpRequestMonitor.prototype.onHttpRequestAbort = function (httpRequest) {
        this.onHttpRequestClose(httpRequest, HttpRequestClose_1.default.Abort);
    };
    HttpRequestMonitor.prototype.onHttpRequestTimeout = function (httpRequest) {
        this.onHttpRequestClose(httpRequest, HttpRequestClose_1.default.Timeout);
        this.emit('timeout');
    };
    HttpRequestMonitor.prototype.onHttpRequestError = function (httpRequest) {
        this.onHttpRequestClose(httpRequest, HttpRequestClose_1.default.Error);
    };
    HttpRequestMonitor.prototype.timeoutAllActiveHttpRequests = function () {
        var _this = this;
        var activeHttpRequests = this.getActiveHttpRequests();
        activeHttpRequests.forEach(function (activeHttpRequest) {
            var SEGMENT = _this.shaka.net.NetworkingEngine.RequestType.SEGMENT;
            if (activeHttpRequest.httpRequest.getRequestType() === SEGMENT) {
                activeHttpRequest.httpRequest.timeout();
            }
        });
    };
    HttpRequestMonitor.prototype.setTimeoutFirstByte = function (ms) {
        var _this = this;
        if (this.config.timeoutFirstByte === ms) {
            return;
        }
        this.config.timeoutFirstByte = ms;
        var now = Date.now();
        Object.keys(this.activeHttpRequests).forEach(function (key) {
            var activeHttpRequest = _this.activeHttpRequests[key];
            if (activeHttpRequest.timeoutFirstByte !== undefined) {
                _this.clearTimeoutFirstByte(activeHttpRequest);
                var elapsed = now - activeHttpRequest.startTime;
                var remaining = Math.max(0, ms - elapsed);
                _this.createTimeoutFirstByte(activeHttpRequest, remaining);
            }
        });
    };
    HttpRequestMonitor.prototype.setTimeoutLoad = function (ms) {
        var _this = this;
        if (this.config.timeoutLoad === ms) {
            return;
        }
        this.config.timeoutLoad = ms;
        var now = Date.now();
        Object.keys(this.activeHttpRequests).forEach(function (key) {
            var activeHttpRequest = _this.activeHttpRequests[key];
            if (activeHttpRequest.timeoutLoad !== undefined) {
                _this.clearTimeoutLoad(activeHttpRequest);
                var elapsed = now - activeHttpRequest.startTime;
                var remaining = Math.max(0, ms - elapsed);
                _this.createTimeoutLoad(activeHttpRequest, remaining);
            }
        });
    };
    HttpRequestMonitor.prototype.emitBandwidthEstimate = function () {
        var bandwidthEstimation = this.bandwidthEstimation;
        bandwidthEstimation.updateBandwidthEstimate();
        var bandwidthEstimate = bandwidthEstimation.getBandwidthEstimate();
        this.emit('bandwidth-estimate', bandwidthEstimate);
    };
    HttpRequestMonitor.prototype.onHttpRequestClose = function (httpRequest, reason) {
        var id = httpRequest.id;
        var internalActiveHttpRequest = this.activeHttpRequests[id];
        if (undefined === internalActiveHttpRequest) {
            return;
        }
        this.clearTimeoutFirstByte(internalActiveHttpRequest);
        this.clearTimeoutLoad(internalActiveHttpRequest);
        delete this.activeHttpRequests[id];
        this.bandwidthEstimation.onHttpRequestClose(id, reason);
        this.emit('http-request-close', {
            id: id,
            reason: reason
        });
    };
    HttpRequestMonitor.prototype.emit = function (event, data) {
        this.eventEmitter.emit(event, data);
    };
    HttpRequestMonitor.prototype.clearIntervalBandwidthEstimate = function () {
        if (undefined !== this.intervalBandwidthEstimate) {
            clearInterval(this.intervalBandwidthEstimate);
            this.intervalBandwidthEstimate = undefined;
        }
    };
    HttpRequestMonitor.prototype.createIntervalBandwidthEstimate = function () {
        var _this = this;
        this.intervalBandwidthEstimate = setInterval(function () {
            _this.emitBandwidthEstimate();
        }, this.config.intervalBandwidthEstimate);
    };
    HttpRequestMonitor.prototype.clearTimeoutFirstByte = function (internalActiveHttpRequest) {
        if (internalActiveHttpRequest.timeoutFirstByte) {
            clearTimeout(internalActiveHttpRequest.timeoutFirstByte);
            internalActiveHttpRequest.timeoutFirstByte = undefined;
        }
    };
    HttpRequestMonitor.prototype.clearTimeoutLoad = function (internalActiveHttpRequest) {
        if (internalActiveHttpRequest.timeoutLoad) {
            clearTimeout(internalActiveHttpRequest.timeoutLoad);
            internalActiveHttpRequest.timeoutLoad = undefined;
        }
    };
    HttpRequestMonitor.prototype.createTimeoutFirstByte = function (internalActiveHttpRequest, remaining) {
        var _this = this;
        var httpRequest = internalActiveHttpRequest.request.httpRequest;
        var ms = this.config.timeoutFirstByte;
        if (remaining !== undefined) {
            ms = remaining;
        }
        internalActiveHttpRequest.timeoutFirstByte = setTimeout(function () {
            _this.clearTimeoutFirstByte(internalActiveHttpRequest);
            httpRequest.timeout();
        }, ms);
    };
    HttpRequestMonitor.prototype.createTimeoutLoad = function (internalActiveHttpRequest, remaining) {
        var _this = this;
        var httpRequest = internalActiveHttpRequest.request.httpRequest;
        var ms = this.config.timeoutLoad;
        if (remaining !== undefined) {
            ms = remaining;
        }
        internalActiveHttpRequest.timeoutLoad = setTimeout(function () {
            _this.clearTimeoutLoad(internalActiveHttpRequest);
            httpRequest.timeout();
        }, ms);
    };
    return HttpRequestMonitor;
}());
exports.default = HttpRequestMonitor;
//# sourceMappingURL=HttpRequestMonitor.js.map